export function escapeContextText(value: string): string {
  return value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function escapeContextAttr(value: string): string {
  return escapeContextText(value).replace(/"/g, "&quot;");
}
